var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.batchData)?_c('div',[_c('VueTree',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"dataset":_vm.batchData,"config":_vm.treeConfig},scopedSlots:_vm._u([{key:"node",fn:function(ref){
var node = ref.node;
var collapsed = ref.collapsed;
return [_c('TreeItem',{attrs:{"node":node,"collapsed":collapsed}})]}}],null,false,3263778536)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }